<template>
  <!--这里是App.vue的路由下-->
  <div class="app-content">
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" :key="mainRefreshKey" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" v-if="!$route.meta.keepAlive" />
    </router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ref, onMounted } from "vue";

export default {
  name: 'App',
  computed: {
    // 使用对象展开运算符将 getter 混入 computed 对象中
    ...mapState(['mainRefreshKey'])
  },
  components: {
  },
  mounted() {
    window.onload= function(){
      document.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      });
      document.addEventListener('gesturestart', function (e) {
        e.preventDefault();
      })
    }
  }
}
</script>

<style></style>
